import { Component } from '@theme/component';

/**
 * Search page input — same field chrome as header predictive search.
 *
 * @typedef {object} Refs
 * @property {HTMLInputElement} searchPageInput - The search input element.
 * @property {HTMLButtonElement} resetButton - The clear button.
 * @extends {Component<Refs>}
 */
class SearchPageInputComponent extends Component {
  requiredRefs = ['searchPageInput', 'resetButton'];

  connectedCallback() {
    super.connectedCallback();

    if (this.refs.searchPageInput.value.trim().length > 0) {
      this.#showResetButton();
    }
  }

  handleInput = () => {
    if (this.refs.searchPageInput.value.trim().length > 0) {
      this.#showResetButton();
    } else {
      this.#hideResetButton();
    }
  };

  handleClear = () => {
    this.refs.searchPageInput.value = '';
    this.#hideResetButton();
    this.refs.searchPageInput.focus();

    if (!this.#isEmptyState()) {
      this.refs.searchPageInput.form?.requestSubmit();
    }
  };

  /**
   * @param {KeyboardEvent} event
   */
  handleKeyDown = (event) => {
    if (event.key !== 'Escape') return;

    const value = this.refs.searchPageInput.value.trim();

    if (value === '') {
      this.#submitEmptySearch();
      return;
    }

    event.preventDefault();
    this.handleClear();
  };

  #submitEmptySearch() {
    const searchInput = this.refs.searchPageInput;

    searchInput.focus();
    searchInput.value = '';
    this.#hideResetButton();

    if (this.#isEmptyState()) return;

    searchInput.form?.requestSubmit();
  }

  #isEmptyState = () => {
    const url = new URL(window.location.href);
    const queryParam = url.searchParams.get('q') ?? '';

    return queryParam.trim() === '';
  };

  #showResetButton() {
    this.refs.resetButton.hidden = false;
  }

  #hideResetButton() {
    this.refs.resetButton.hidden = true;
  }
}

if (!customElements.get('search-page-input-component')) {
  customElements.define('search-page-input-component', SearchPageInputComponent);
}
